export const team = [
  {
    name: "Centaur",
    role: "Artist & Co-founder",
    bio:
      "Pixel artist behind NFT-People. Designed the generative collection and visual identity on Tezos.",
    avatar: "/images/team/centaur.svg", // if missing, fall back to initials
    links: {
      x: "https://x.com/Centaur_Cave",
      objkt: "" // leave empty if none; renderer should hide it
    }
  },
  {
    name: "Navid Aliz",
    role: "Developer & Co-founder",
    bio:
      "Full-stack developer and Tezos builder. Built the rarity tool, website, and project automations.",
    avatar: "/images/team/navid.svg",
    links: {
      x: "https://x.com/navid_aliz",
      linkedin: "https://www.linkedin.com/in/navid-aliz/",
      website: "" // optional
    }
  }
];
